import Vue from 'vue'
let self = new Vue();

export default {
    setHy: function (val) {
        self.$utils.localSet('hy', JSON.stringify(val));
    },
    getHy: function () {
        return JSON.parse(self.$utils.localGet('hy'));
    },
    setArea: function (val) {
        self.$utils.localSet('area', JSON.stringify(val));
    },
    getArea: function () {
        return JSON.parse(self.$utils.localGet('area'));
    },

    setHy2: function (val) {
        self.$utils.localSet('hy2', val);
    },
    getHy2: function () {
        return self.$utils.localGet('hy2');
    },
    setArea2: function (val) {
        self.$utils.localSet('area2', JSON.stringify(val));
    },
    getArea2: function () {
        return JSON.parse(self.$utils.localGet('area2'));
    },

    setDingyueOpenid: function (val) {
        self.$utils.localSet('dingyue_openid', val ? val : '');
    },
    getDingyueOpenid: function () {
        return self.$utils.localGet('dingyue_openid');
    },
    setFuwuOpenid: function (val) {
        self.$utils.localSet('dingyue_openid', val ? val : '');
    },
    getFuwuOpenid: function () {
        return self.$utils.localGet('dingyue_openid');
    },

    setMobile: function (val) {
        self.$utils.localSet('mobile', val ? val : '');
    },
    getMobile: function () {
        return self.$utils.localGet('mobile');
    },
    setToken: function (val) {
        self.$utils.localSet('token', val ? val : '');
    },
    getToken: function () {
        return self.$utils.localGet('token');
    },
    setICode: function (val) {
        self.$utils.localSet('icode', val.toString());
    },
    getICode: function () {
        return self.$utils.localGet('icode');
    },

    setUid: function (val) {
        self.$utils.localSet('uid', val ? val : '');
    },
    getUid: function () {
        return self.$utils.localGet('uid');
    },

    setUserName: function (val) {
        self.$utils.localSet('username', val ? val : '');
    },
    getUserName: function () {
        return self.$utils.localGet('username');
    },

    setMySign: function (val) {
        self.$utils.localSet('my_sign', val ? val : '');
    },
    getMySign: function () {
        return self.$utils.localGet('my_sign');
    },

    setMyDes: function (val) {
        self.$utils.localSet('my_des', val ? val : '');
    },
    getMyDes: function () {
        return self.$utils.localGet('my_des');
    },

    setRegType: function (val) {
        self.$utils.localSet('regtype', val);
    },
    getRegType: function () {
        return self.$utils.localGet('regtype');
    },

    setProvinceCode: function (val) {
        self.$utils.localSet('province_code', val ? val : '');
    },
    getProvinceCode: function () {
        return self.$utils.localGet('province_code');
    },

    setProvinceName: function (val) {
        self.$utils.localSet('province_name', val ? val : '');
    },
    getProvinceName: function () {
        return self.$utils.localGet('province_name');
    },

    setNickname: function (val) {
        self.$utils.localSet('nickname', val ? val : '');
    },
    getNickname: function () {
        return self.$utils.localGet('nickname');
    },

    setName: function (val) {
        self.$utils.localSet('name', val ? val : '');
    },
    getName: function () {
        return self.$utils.localGet('name');
    },

    setAvatar: function (val) {
        self.$utils.localSet('avatar', val ? val : '');
    },
    getAvatar: function () {
        return self.$utils.localGet('avatar');
    },

    setSfzCode: function (val) {
        self.$utils.localSet('sfz_code', val ? val : '');
    },
    getSfzCode: function () {
        return self.$utils.localGet('sfz_code');
    },

    setBirthday: function (val) {
        self.$utils.localSet('birthday', val);
    },
    getBirthday: function () {
        return self.$utils.localGet('birthday');
    },

    setGold: function (val) {
        self.$utils.localSet('gold', val);
    },
    getGold: function () {
        return self.$utils.localGet('gold');
    },

    setCharm: function (val) {
        self.$utils.localSet('charm', val);
    },
    getCharm: function () {
        return self.$utils.localGet('charm');
    },

    setIsRealname: function (val) {
        self.$utils.localSet('is_realname', val);
    },
    getIsRealname: function () {
        let _v = self.$utils.localGet('is_realname');
        return _v !== 0;
    },

    setIsMobile: function (val) {
        self.$utils.localSet('is_mobile', val);
    },
    getIsMobile: function () {
        let _v = self.$utils.localGet('is_mobile');
        return _v !== 0;
    },

    setIsMaster: function (val) {
        self.$utils.localSet('is_master', val);
    },
    getIsMaster: function () {
        let _v = self.$utils.localGet('is_master');
        return _v !== 0;
    },

    setIsWechat: function (val) {
        self.$utils.localSet('is_wechat', val);
    },
    getIsWechat: function () {
        let _v = self.$utils.localGet('is_wechat');
        return _v !== 0;
    },

    logout(){
        self.$utils.localDel('token');
        self.$utils.localClear();
    }

    // getAll: function () {
    //     let _all = self.$utils.localGetInfo();
    //
    //     let _keys = _all.keys;
    //
    //     let _out = {};
    //
    //     for (let i = 0; i < _keys.length; i++) {
    //         if (_keys[i].indexOf('is_') === 0) {
    //             let _v = self.$utils.localGet(_keys[i]);
    //             _out[_keys[i]] = parseInt(_v) === 0 ? false : true;
    //         } else if (_keys[i] === 'regtype') {
    //             _out[_keys[i]] = parseInt(self.$utils.localGet(_keys[i]));
    //         } else if (_keys[i] === 'papers') {
    //             _out[_keys[i]] = JSON.parse(self.$utils.localGet(_keys[i]));
    //         } else {
    //             _out[_keys[i]] = self.$utils.localGet(_keys[i]);
    //         }
    //     }
    //
    //     return _out;
    // },
}
